import style from './NavBar.module.css'
import NavLinks from '../../UI/NavLinks/NavLinks'
import { useLocation } from 'react-router-dom';
import { ReactComponent as Triangle } from '../../Assets/icons/Triangle.svg';
import { ReactComponent as TriangleLeft } from '../../Assets/icons/TriangleLeft.svg';

export default function NavBar({setIsOpen, isOpen}){
    const location = useLocation().pathname
    
    return <div className={`${style.nav} ${isOpen && style.active}`}>
       <div className={style.logo}></div>
       <NavLinks location={location} />
       <button className={style.btnOpen} onClick={() => setIsOpen(!isOpen)}>{isOpen ? <TriangleLeft /> : <Triangle /> }</button>
    </div>

}